/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ShopBreadcrumbs_landingPage$ref = any;
type ShopCarousel_landingPage$ref = any;
type ShopGrid_landingPage$ref = any;
type ShopList_landingPage$ref = any;
export type ShopWrapper_landingPage$ref = any;
export type ShopWrapper_landingPage = {
    readonly title: string | null;
    readonly description: string | null;
    readonly " $fragmentRefs": ShopBreadcrumbs_landingPage$ref & ShopCarousel_landingPage$ref & ShopGrid_landingPage$ref & ShopList_landingPage$ref;
    readonly " $refType": ShopWrapper_landingPage$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShopWrapper_landingPage",
  "type": "LandingPage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ShopBreadcrumbs_landingPage",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ShopCarousel_landingPage",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ShopGrid_landingPage",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ShopList_landingPage",
      "args": null
    }
  ]
};
(node as any).hash = 'c5f848ccd6bd9ad3c866e60059002613';
export default node;
